import { uuidv7 } from "./uuidv7.js";
//#region ../uuid/dist/uuid25.js
function toUuid25(bytes) {
	if (bytes.length !== 16) throw new RangeError(`A UUID is 16 bytes, not ${bytes.length}`);
	let value = 0n;
	for (const byte of bytes) value = value << 8n | BigInt(byte);
	return value.toString(36).padStart(25, "0");
}
var uuid25 = () => toUuid25(uuidv7());
//#endregion
export { toUuid25, uuid25 };
